module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/edit-error-icon.af18cec7.svg";